"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var SmoothScroll = /** @class */ (function () {
    function SmoothScroll() {
        this.init();
    }
    SmoothScroll.getInstance = function () {
        return new SmoothScroll();
    };
    SmoothScroll.prototype.init = function () {
        var $scrollLink = $('[data-goto]');
        if ($scrollLink.length === 0) {
            return;
        }
        var $htmlBody = $('html,body');
        $scrollLink.on('click', function (e) {
            e.preventDefault();
            var extraTop = 40;
            var $target = $('#' + $(this).data('goto'));
            if ($target.length > 0) {
                $htmlBody.stop(true).animate({
                    'scrollTop': ($('#' + $(this).data('goto')).first().offset().top - extraTop) + 'px'
                }, 400);
            }
        });
    };
    return SmoothScroll;
}());
exports.default = SmoothScroll;
